import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { IPlacementTest } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray, } from 'src/app/services/convert.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';

@Component({
  selector: 'app-add-placement-vocabulary-quiz',
  templateUrl: './add-placement-vocabulary-quiz.component.html',
  styleUrls: ['./add-placement-vocabulary-quiz.component.scss']
})
export class AddPlacementVocabularyQuizComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create quiz"
  form: FormGroup;
  block: AbstractControl;
  isFill: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<AddPlacementVocabularyQuizComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: PlacementTest,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route: Router,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      block: [null, Validators.compose([Validators.required])],
      isFill: [false, Validators.required]
    })
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { block, isFill } = f;
      const { FORM, ITEM, QUESTION } = this.data;
      const { name } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const { questions } = ITEM;
      const blocks = { isFill: isFill, name: `${block}`.trim(), key: this.ds.createId() };
      const BLOCKS_DATA = pushObjArray(QUESTION.block, blocks)
      const QUESTION_ITEM = { key: QUESTION.key, name: QUESTION.name, block: BLOCKS_DATA }

      const QUESTION_DATA = pushObjArray(questions, QUESTION_ITEM)
      const registerStatus = isDraft ? STATUS_OBJECT.submitted : STATUS_OBJECT.submitted;

      const activity: IPlacementTest = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        tip: name || null,
        questions: QUESTION_DATA || [],
        skillKey: ITEM.skillKey,
        testingTypeKey: ITEM.testingTypeKey,
      }
      this.store.addItem(activity, (success, res) => {
        this.data.QUESTION=QUESTION_ITEM;
        this.data.ITEM = activity;
        this.snackBar.open("Question has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}